import {
  Calculator, Globe2, FileSpreadsheet, ScrollText, Landmark, PiggyBank,
  Receipt, TrendingUp, Wallet, ClipboardCheck, Building2, Boxes,
} from "lucide-react";

export const LOGO = "/ancion-logo.png";
export const MARK = "/ancion-mark.png";

export const CONTACT = {
  email: "info@ancionconsulting.com",
  phone: "438-933-1373",
  location: "Pointe-Calumet, Québec, Canada",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Boutique", href: "#boutique" },
  { label: "Contact", href: "#contact" },
];

export const FULL_MENU = [
  { label: "Services", href: "#services" },
  { label: "Boutique", href: "#boutique" },
  { label: "Contact", href: "#contact" },
  { label: "Track Record", href: "#record" },
  { label: "About Us", href: "#about" },
];

export const MARQUEE_ITEMS = [
  "International Transactions", "Consolidation", "Month & Year Ends", "Audit Support",
  "Sales Tax", "Corporate Income Tax", "Budgeting & Forecasting", "Cost Analysis",
  "Bookkeeping", "Payroll", "AP / AR", "Reconciliation", "Tax Credits & Grants",
];

export const ACCOUNTING_SERVICES = [
  { icon: PiggyBank, title: "Bookkeeping", desc: "Accurate day-to-day books for companies across a range of industries." },
  { icon: ScrollText, title: "Accounts Payable / Receivable", desc: "High-volume AP/AR, billing, collections and supplier reconciliation." },
  { icon: FileSpreadsheet, title: "Month-End & Year-End Close", desc: "Closing journal entries, reviews and full cycle close managed to deadline." },
  { icon: ClipboardCheck, title: "Audit Preparation & Support", desc: "Internal audits and complete tax & audit document packages for external firms." },
  { icon: Receipt, title: "Sales Tax Filing", desc: "GST/QST and US/Swiss sales tax reporting for all entities, filed on time." },
  { icon: Landmark, title: "Corporate Income Tax", desc: "Corporate tax coordination plus Federal & Provincial R&D tax credit preparation." },
  { icon: TrendingUp, title: "Budgeting & Forecasting", desc: "Sales projections, budgets and financial performance analysis for the road ahead." },
  { icon: Calculator, title: "Cost & Financial Analysis", desc: "Ratio analysis, cost breakdowns and variance investigation of results vs. forecast." },
  { icon: Wallet, title: "Payroll", desc: "Full payroll administration and compliance across multiple jurisdictions." },
  { icon: Boxes, title: "Inventory & Grants", desc: "Multi-location inventory management and Federal grant & subvention tracking." },
  { icon: Globe2, title: "International Accounting", desc: "Intercompany transactions and multi-entity books across Canada, the US & Europe." },
  { icon: Building2, title: "Consolidations", desc: "Monthly & quarterly consolidation of subsidiaries into clean, audit-ready statements." },
];

export const OTHER_SERVICES = [
  {
    tag: "02",
    title: "Marketing Strategy",
    desc: "Prospection strategies and marketing projects designed to lift periodic sales — informed by a formal specialization in Marketing and hands-on advisory for growing firms.",
    points: ["Digital Marketing", "Prospection & sales growth strategy", "Go-to-market advisory", "Performance-driven positioning"],
  },
  {
    tag: "03",
    title: "Recruiting Services",
    desc: "End-to-end hiring support: sourcing, interviewing candidates and HR coordination so your team scales with the right people at the right time.",
    points: ["Candidate sourcing & screening", "Structured interviewing", "HR process & onboarding"],
  },
];

export const EXPERIENCE = [
  { period: "2023 — 2026", role: "Senior Accountant", org: "Syneos Health LP, Toronto, Ont", note: "R&D tax credits, reconciliations, inventory across QC, Princeton & Miami." },
  { period: "2022 — Now", role: "Accounting Consultant", org: "Independent, Montréal, Qc", note: "Bookkeeping, financials, budgeting & forecasting for CA & US clients." },
  { period: "2020 — 2022", role: "Accountant", org: "Thevoz Attorneys, Austin TX", note: "Full accounting cycles & payroll for Swiss and US firms." },
  { period: "2016 — 2019", role: "Staff Accountant", org: "Kent Security, Miami FL", note: "Internal audits & consolidation across five state subsidiaries." },
  { period: "2014 — 2016", role: "Accountant", org: "Atome Distributeur Inc., Montréal, Qc", note: "Managed cash flow, AP/AR & billing, daily entries, bank reconciliations, tax reports and budgets." },
  { period: "2014", role: "Accounting Specialist", org: "TUI Leisure Travel / Ascendo (Consultant), Miami FL", note: "Cost analysis of cruise ships and processed high volumes of AP & AR." },
  { period: "2013", role: "Accounting Teacher", org: "Collège Essor, Montréal, Qc", note: "Built a course from scratch and taught the basics of accounting to students enrolled in an intensive program that leads to an internship on the job market." },
  { period: "2005 — 2012", role: "Financial Analyst", org: "National Bank of Canada, Montréal, Qc", note: "Corporate loan analysis, valuations & financial consolidation." },
];

export const STATS = [
  { value: "20+", label: "Years in accounting" },
  { value: "30+", label: "Companies supported" },
];
